/**
 * Path relativa tra due nodi di un albero di configurazione.
 * Serve per evitare problemi in caso di spostamento di una sezione intera
 * con più riferimenti allo stesso livello (es. _sibling_)
 *
 * /!\ È fondamentale che i path _non_ siano relativi ai diversi container
 * (es. righe) che si possono avere all'interno di un albero di configurazione,
 * ma solamente ai nodi che hanno un _valore_ (es. un widget di input, una lista).
 * Altrimenti si rischia di avere problemi di riferimento in caso di spostamento
 * puramente grafico di un nodo.
 */
export type IReferencePath = IReferencePathItem[];

export interface IReferencePathItem {
  direction: ReferencePathDirection;
  code: string;
}

export enum ReferencePathDirection {
  Parent = 'parent',
  Sibling = 'sibling',
  Child = 'child',
  /** Nodo che parte da un'altra root */
  Root = 'root',
  /** Nodo "assoluto", es valori di sessione */
  Absolute = 'absolute',
}
